import React from 'react';
import marked from 'marked'

import styles from './BannerLink.module.scss';

const BannerLink = (props) => (
  <div className={props.reducedPadding ? styles.ReducedBannerLink : styles.BannerLink}>
    <h2 className="h2" style={props.alignCenter ? { textAlign: 'center' } : {}}>{props.title}</h2>
    {
        props.content &&
        <p dangerouslySetInnerHTML={{ __html: marked(props.content) }} style={props.alignCenter ? { textAlign: 'center' } : {}} />
    }
    <a href={ props.link } className={styles.Button}>{ props.linkText }</a>
  </div>
)

export default BannerLink;



// WEBPACK FOOTER //
// ./src/components/BannerLink/index.js